import { DSNCDealsSimple } from 'shared-definitions/types'
import { ApiComponentDealsListProps } from 'data-source/types.wp'
import { dealsButtonMapper } from 'data-source/mappers/dealsButtonMapper'
import { optionalLinkMapper } from 'data-source/mappers/optionalLinkMapper'
import { PLinkMapperOpts } from './pLinkMapper'

export function ncDealsList(
  input: ApiComponentDealsListProps,
  opts: PLinkMapperOpts
): DSNCDealsSimple[] {
  return input.deals.flatMap(item => ({
    resource: 'nc-deals-simple',
    dataAttrs: item.data_attributes ?? {},
    pLinkRequestUpdate: null,
    pLinkEdit: optionalLinkMapper(item.edit_url),
    title: item.title,
    refLink: null,
    anchor: null,
    buttons: [dealsButtonMapper(item, opts)],
    msrp: null,
    textBadge: null,
  }))
}
